var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.landSize)?_c('span',[_c('span',[_vm._v(_vm._s(_vm.landSize.landSize))]),_vm._v("   "),_c('small',[_vm._v(_vm._s(_vm.landSize.unit))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }